import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import UsersTable from './UsersTable';
import UserGroupsSettings from './UserGroupsSettings';
import RolesComponentSetting from '../modules-menu/user-access/RoleSettingsAccess';
import {IconButton, Typography, useTheme} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import backgroundImage from 'src/assets/images/low_res_background_light.png';
import {PRIVATE_ROUTES} from 'src/routes/RouteConstants';
import {BASE_ROUTE, UAM} from 'src/routes/BaseRoute';
import {useNavigate} from 'react-router-dom';
import FormConstants from '@shared/constants/FormConstants';
import {getUAMTabPermissions} from '@shared/services/service-handlers/PrivateService';
import {CenterCircularProgress} from '../dashboard/DashboardStyles';
import {PulseLoader} from 'react-spinners';
interface TabPanelProps {
  children?: React.ReactNode;
  index: string;
  value: string;
}

function CustomTabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{p: 3}}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
const tabsData = [
  {
    id: 1,
    object: 'users',
    function: 'view',
    object_label: 'Users'
  },
  {
    id: 2,
    object: 'usergroups',
    function: 'view',
    object_label: 'User Groups'
  },
  {
    id: 3,
    object: 'roles',
    function: 'view',
    object_label: 'Roles'
  }
];

export default function UAMDashboard() {
  const theme = useTheme();
  const [value, setValue] = React.useState('users');
  const [tabs, setTabs] = React.useState<any>([...tabsData]);
  const [loading, setLoading] = React.useState(true);
  const params = new URLSearchParams(location.search);
  const selectedtab = params.get('selected_tab');
  const navigate = useNavigate();
  React.useEffect(() => {
    const selectedTabFromStorage = async () => {
      setLoading(true);
      const value = await getUAMTabPermissions();
      setValue('users');
      navigate(
        `/${BASE_ROUTE}/${UAM}?${
          FormConstants.USER_ACCESS.SELECTED_TAB +
          '=' +
          'users'
        }`,
        {
          state: {}
        }
      );
      if (value.data.length === 0) {
        setTabs([]);
        setLoading(false);
        return;
      }
      setTabs(tabs);
      setLoading(false);
    };
    selectedTabFromStorage();
  }, []);
  React.useEffect(() => {
    if (selectedtab) {
      setValue(selectedtab);
    }
  }, [selectedtab]);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    navigate(
      `/${BASE_ROUTE}/${UAM}?${
        FormConstants.USER_ACCESS.SELECTED_TAB + '=' + `${newValue}`
      }`,
      {
        state: {}
      }
    );
  };

  return loading ? (
    <CenterCircularProgress>
      <PulseLoader color={theme.palette.primary.main} />
    </CenterCircularProgress>
  ) : (
    <Box sx={{width: '100%'}}>
      {tabs.length > 0 ? (
        <>
          <Box sx={{backgroundColor: 'rgb(7, 59, 76)'}}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                marginLeft: 5,
                marginTop: 1,
                display: 'flex',
                alignItems: 'anchor-center',
                justifyContent: 'space-between'
              }}>
              {/* <Box sx={{display:'flex',alignItems:'baseline',justifyContent:'space-between'}}> */}
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                sx={{
                  mt: {xs: 3, md: 2},
                  color: 'rgb(6, 214, 160)',
                  borderBottom: 'rgb(6, 214, 160)'
                }}
                TabIndicatorProps={{
                  style: {
                    color: 'rgb(6, 214, 160)'
                  }
                }}>
                {tabs.map((tab: any, index: number) => (
                  <Tab
                    key={tab.id}
                    label={tab.object_label}
                    value={tab.object}
                    {...a11yProps(index)}
                  />
                ))}
              </Tabs>
              <Box
                display={'flex'}
                justifyContent={'flex-start'}
                alignItems={'center'}
                sx={{marginRight: 8, color: 'white'}}>
                <IconButton
                  onClick={() => {
                    navigate(`/${BASE_ROUTE}/${PRIVATE_ROUTES.DASHBOARD}`, {
                      state: {}
                    });
                  }}
                  size="small">
                  <ArrowBackIcon sx={{color: 'white'}} />
                </IconButton>
                <Typography variant="h1">Dashboard</Typography>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              backgroundImage: `url(${backgroundImage})`,
              minHeight: '100vh',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundAttachment: 'fixed'
            }}>
            <CustomTabPanel value={value} index={'users'}>
              <UsersTable />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={'usergroups'}>
              <UserGroupsSettings />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={'roles'}>
              <RolesComponentSetting />
            </CustomTabPanel>
          </Box>
        </>
      ) : (
        <Box
          sx={{
            backgroundImage: `url(${backgroundImage})`,
            minHeight: '100vh',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundAttachment: 'fixed',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 2
          }}>
          <Typography variant="h4" sx={{color: 'black'}}>
            You do not have access to User Access Management
          </Typography>
          <IconButton
            onClick={() => {
              navigate(`/${BASE_ROUTE}/${PRIVATE_ROUTES.DASHBOARD}`, {
                state: {}
              });
            }}
            size="small">
            <ArrowBackIcon sx={{color: 'black'}} />
          </IconButton>
        </Box>
      )}
    </Box>
  );
}
